import { useScrollLock as p } from "@vueuse/core";
import { defineComponent as c, ref as d, computed as f, resolveComponent as i, openBlock as m, createBlock as u, withCtx as k, createElementVNode as y, mergeProps as v, renderSlot as O } from "vue";
import { useElevation as b } from "@onereach/ui-components-common/hooks";
import { O as C } from "./OrTeleport.vue3-C9kW_8PS.mjs";
import { _ as $ } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const g = [
  // Position
  "fixed inset-0",
  // Layout
  "layout-row justify-center",
  // Theme
  "theme-background-overlay",
  "dark:theme-background-overlay-dark",
  "theme-foreground-base",
  "dark:theme-foreground-base"
], h = c({
  name: "OrOverlay",
  components: {
    OrTeleport: C
  },
  inheritAttrs: !1,
  props: {
    fullscreen: {
      type: Boolean,
      default: !1
    }
  },
  expose: [
    "root"
  ],
  setup(e, o) {
    const r = d(), t = f(() => [
      "or-overlay-v3",
      ...g
    ]);
    b(r), p(document.body, !0);
    function n(s) {
    }
    return {
      root: r,
      rootStyles: t,
      onClick: n
    };
  }
});
function S(e, o, r, t, n, s) {
  const l = i("OrTeleport");
  return m(), u(l, {
    disabled: !e.fullscreen
  }, {
    default: k(() => [
      y("div", v(e.$attrs, {
        ref: "root",
        class: e.rootStyles,
        onClick: o[0] || (o[0] = (...a) => e.onClick && e.onClick(...a))
      }), [
        O(e.$slots, "default")
      ], 16)
    ]),
    _: 3
  }, 8, ["disabled"]);
}
const j = /* @__PURE__ */ $(h, [["render", S]]);
export {
  j as O
};
//# sourceMappingURL=OrOverlay-BjrghiC-.mjs.map
